import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiClient {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  private getDefaultHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      // Aquí podrías agregar token o headers extra si lo necesitas más adelante
    });
  }

  get<T>(path: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}${path}`, {
      headers: this.getDefaultHeaders(),
      params
    });
  }

  post<T>(path: string, body: unknown): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}${path}`, body, {
      headers: this.getDefaultHeaders()
    });
  }

  put<T>(path: string, body: unknown): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}${path}`, body, {
      headers: this.getDefaultHeaders()
    });
  }

  delete<T>(path: string, body?: any): Observable<T> {
    return this.http.request<T>('DELETE', `${this.baseUrl}${path}`, {
      body,
      headers: this.getDefaultHeaders()
    });
  }


  getImageUrl(path: string): Observable<string> {
    return this.http
      .get(`${this.baseUrl}${path}`, { responseType: 'blob' }) // ✅ el interceptor inyecta el token
      .pipe(map(blob => URL.createObjectURL(blob)));
  }
}
